$(document).on('click', '.column-switch', function(){
    var formData = new FormData();

    var controller = $(this).attr('data-controller');
    var showColumn = $(this).attr('data-show-column');
    var hideColumn = $(this).attr('data-hide-column');

    $('.' + showColumn + '-cell').show();
    $('.' + showColumn + '-head').show();
    $('.' + showColumn + '-column-switch').show();
    $('.' + hideColumn + '-cell').hide();
    $('.' + hideColumn + '-head').hide();
    $('.' + hideColumn + '-column-switch').hide();

    formData.append('tx_tuevnordcustomerportal_api[settings][' + controller + '][' + hideColumn + ']', false);
    formData.append('tx_tuevnordcustomerportal_api[settings][' + controller + '][' + showColumn + ']', true);

    var request = window.xhrRequest({
        url: $(this).attr('data-url'),
        method: 'POST',
        data: formData
    });

    request.then((response) => {

    }).catch((e) => {
        reject(e);
    });
});